import React, { useEffect, useState } from "react";
import SecondLayout from "../../../layouts/SecondLayout";
import Cookies from "js-cookie";
import { Variables } from "../../../variables";

const UsEuropeCountries = () => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");
  const [content, setContent] = useState([]);

  // loader + error
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // watch language cookie
  useEffect(() => {
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => (prev !== currentLang ? currentLang : prev));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const directionClass = language === "ar" ? "text-right direction-rtl" : "";

  // fetch content (show ONLY loader/error without layout; show layout after)
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const url =
          Variables.API_URL +
          "Rasha/Client/Page/5?isEnglish=" +
          (language === "en");

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result?.message || "Failed to fetch content");
        }

        if (isMounted) setContent(Array.isArray(result) ? result : []);
      } catch (err) {
        if (isMounted && err.name !== "AbortError") {
          setError(err.message || "Something went wrong");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [language]);

  // --- Loader (no layout) ---
  if (loading) {
    return (
      <div style={styles.loaderWrap}>
        <div style={styles.spinner} />
      </div>
    );
  }

  // --- Error (no layout) ---
  if (error) {
    return <div style={styles.errorBox}>{error}</div>;
  }

  // --- Main UI (with layout AFTER loading) ---
  return (
    <SecondLayout>
      <div className={`container main-container-beauty ${directionClass}`}>
        {(content || []).map((c, i) => {
          const key = c?.WidgetId ?? `${c?.WidgetTypeId || "w"}-${c?.WidgetValue?.Id || i}`;
          const img = Variables.API_PUBLISHED + (c?.WidgetValue?.ImageUrl || "");
          const text = language === "en" ? c?.WidgetValue?.Body : c?.WidgetValue?.BodyAr;
          const btnText =
            language === "en" ? c?.WidgetValue?.ButtonText : c?.WidgetValue?.ButtonTextAr;
          const btnUrl = c?.WidgetValue?.ButtonUrl || "#";

          return (
            <div key={key} className="card-beauty">
              <img
                src={img}
                alt={`beauty-us-europe-${i}`}
                style={{ width: "100%" }}
              />
              <div className="container-beauty text-center card-body">
                <div className="card-text">
                  <h4>
                    <b>{text}</b>
                  </h4>
                </div>
                <button
                  className="UsEuropeCountries-btn"
                  onClick={() => (window.location.href = btnUrl)}
                >
                  {btnText}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </SecondLayout>
  );
};

const styles = {
  loaderWrap: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    width: 48,
    height: 48,
    border: "4px solid rgba(0,0,0,0.1)",
    borderTopColor: "#000",
    borderRadius: "50%",
    animation: "spin 0.9s linear infinite",
  },
  errorBox: {
    margin: 16,
    padding: "12px 16px",
    border: "1px solid #f3c2c2",
    background: "#fff5f5",
    color: "#b00020",
    borderRadius: 8,
  },
};

// inject keyframes (once)
if (typeof document !== "undefined" && !document.getElementById("useurope-spin-kf")) {
  const styleEl = document.createElement("style");
  styleEl.id = "useurope-spin-kf";
  styleEl.innerHTML = `@keyframes spin { to { transform: rotate(360deg); } }`;
  document.head.appendChild(styleEl);
}

export default UsEuropeCountries;
